import { Padrao } from '../generic/padrao';
import { AutoRegisterClass } from 'src/app/services/generics/classRegistry';

@AutoRegisterClass()
export class Departamento extends Padrao{

    override idTab = 94;

    descricao: string;
}